import { useContentArea, withinOrWiderThan } from '@udemy/react-layout-components';
import classNames from 'classnames';
import React from 'react';
import { CardSecondaryContent } from './card-secondary-content.react-component';
import commonStyles from "./common-card.module.css";
import styles from "./condensed-card.module.css";
/** React props for `CondensedCard` component */

/**
 * ### CondensedCard component
 *
 * @remarks
 *
 * A card layout with a left-aligned, fixed-width square media item and a
 * horizontal layout of content.
 *
 * This card is suitable for spanning 3-12 columns in the content area grid.
 */
export const CondensedCard = _ref => {
  var _ref2, _ref3;

  let {
    action,
    authors,
    className,
    description,
    iconButton,
    inlineSecondaryContent,
    media,
    progress,
    secondaryContent,
    showSecondaryContentBorder = true,
    tags,
    title,
    statusLabel
  } = _ref;
  const {
    range,
    isRangeKnown
  } = useContentArea(); // If range is not known (server-side, or first render), then render all
  // secondary content and rely on CSS to determine its visibility based on
  // the content area range with container queries.

  const renderInlineSecondaryContent = inlineSecondaryContent && (!isRangeKnown || withinOrWiderThan(range, 'sm'));
  const renderSecondaryContent = secondaryContent && (!isRangeKnown || !(inlineSecondaryContent && withinOrWiderThan(range, 'sm')));
  const hasPrimaryBottom = (_ref2 = (_ref3 = tags !== null && tags !== void 0 ? tags : progress) !== null && _ref3 !== void 0 ? _ref3 : statusLabel) !== null && _ref2 !== void 0 ? _ref2 : action;
  return /*#__PURE__*/React.createElement("section", {
    className: classNames(styles.card, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.primary
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.media
  }, media), /*#__PURE__*/React.createElement("div", {
    className: styles['primary-top']
  }, /*#__PURE__*/React.createElement("div", {
    className: commonStyles['primary-head']
  }, /*#__PURE__*/React.createElement("div", null, title), description && /*#__PURE__*/React.createElement("div", null, description), authors && /*#__PURE__*/React.createElement("div", null, authors))), hasPrimaryBottom && /*#__PURE__*/React.createElement("div", {
    className: styles['primary-bottom']
  }, tags && /*#__PURE__*/React.createElement("div", null, tags), progress && /*#__PURE__*/React.createElement("div", {
    className: styles.progress
  }, progress), (statusLabel || action) && /*#__PURE__*/React.createElement("div", {
    className: commonStyles['primary-content-spread']
  }, statusLabel && /*#__PURE__*/React.createElement("div", null, statusLabel), action && /*#__PURE__*/React.createElement("div", null, action))), iconButton && /*#__PURE__*/React.createElement("div", {
    className: styles['icon-button']
  }, iconButton), renderInlineSecondaryContent && /*#__PURE__*/React.createElement("div", {
    className: styles['inline-secondary']
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['inline-secondary-content'], {
      [styles['without-border']]: !showSecondaryContentBorder
    })
  }, inlineSecondaryContent))), renderSecondaryContent && /*#__PURE__*/React.createElement(CardSecondaryContent, {
    className: classNames(styles['secondary-content'], {
      [styles['with-inline-secondary-content']]: inlineSecondaryContent
    }),
    showBorder: showSecondaryContentBorder
  }, secondaryContent));
};
//# sourceMappingURL=condensed-card.react-component.js.map